import { reaction } from "mobx"
import {localizationService} from 'core/services';

class TitleStore {
    constructor(rootStore) {
        reaction(
            () => rootStore.routerStore.routerState,
            () => this.handleRouteChange(rootStore.routerStore)
        );

        // i18next translations load async; if the first routerState change
        // fires before they're ready, t(key) returns the raw key. Re-run the
        // title set when translations finish loading or the language changes.
        const refresh = () => this.handleRouteChange(rootStore.routerStore);
        if (localizationService.on) {
            localizationService.on('initialized', refresh);
            localizationService.on('languageChanged', refresh);
            localizationService.on('loaded', refresh);
        }
    }

    handleRouteChange(routerStore) {
        const route = routerStore.getCurrentRoute();
        if (!route) return;
        const key = route.tabTitle;
        if (!key) return;
        // `exists` below cannot tell "not a translation key" from "namespace still
        // fetching", so on a cold-cache load it would report false for a real key
        // and write the raw key into the tab. Bail out until the namespace lands —
        // the document keeps index.html's default title, and the
        // localizationService listeners in the constructor re-run this.
        if (!localizationService.hasLoadedNamespace(localizationService.options.defaultNS)) return;
        // A tabTitle is either an i18n key (e.g. "MENU.FACILITY") or a literal
        // string (e.g. "Create User"). For a known key, use its translation; for
        // a literal, use it verbatim. `exists` is what distinguishes the two — the
        // old `t(key) !== key` guard also suppressed every literal title, since a
        // literal's translation IS the key.
        const title = localizationService.exists(key) ? localizationService.t(key) : key;
        if (title) {
            this.setTitle(title);
        }
        // title = route.pattern
        // .replaceAll("-", " ")
        // .split(" ")
        // .map(w => w && w[0].toUpperCase() + w.substr(1))
        // .join(" ")
        // .split("/")
        // .filter(w => !w.includes(":"))
        // .reverse()
        // .map(w => w && w[0].toUpperCase() + w.substr(1))
        // .join(" ");
        // this.setTitle(title); 
    }

    setTitle(title) {
        document.title = title;
    }
}

export default TitleStore;
